export enum ReferralAdminReferralsSortFieldEnum {
  DateAdded = 'dateAdded',
  CreatedAt = 'createdAt',
  Ip = 'ip',
  DepositTotal = 'depositTotal',
  PayoutsTotal = 'payoutsTotal',
  BonusPoints = 'bonusPoints',
  TotalRewardCoins = 'totalRewardCoins',
}

export enum ReferralAdminReferralsSortDirectionEnum {
  Asc = 'asc',
  Desc = 'desc',
}

export const REFERRAL_ADMIN_REFERRALS_SORT_OPTIONS = [
  { value: ReferralAdminReferralsSortFieldEnum.DateAdded, label: 'Регистрация' },
  { value: ReferralAdminReferralsSortFieldEnum.CreatedAt, label: 'Стал рефом' },
  { value: ReferralAdminReferralsSortFieldEnum.Ip, label: 'IP' },
  { value: ReferralAdminReferralsSortFieldEnum.DepositTotal, label: 'Депозиты' },
  { value: ReferralAdminReferralsSortFieldEnum.PayoutsTotal, label: 'Выводы' },
  { value: ReferralAdminReferralsSortFieldEnum.BonusPoints, label: 'Баланс' },
  {
    value: ReferralAdminReferralsSortFieldEnum.TotalRewardCoins,
    label: 'Доход за период',
  },
];

export function getReferralAdminReferralsSortBy(
  field: ReferralAdminReferralsSortFieldEnum,
  direction: ReferralAdminReferralsSortDirectionEnum,
): string {
  return direction === ReferralAdminReferralsSortDirectionEnum.Desc
    ? `-${field}`
    : field;
}
